import React from "react";
import SMSAnalytics from "../../../components/Pages/Campaign/General/SMSAnalytics";

const AnalyticsSMS = () => {
  return (
    <div>
      <SMSAnalytics />
    </div>
  );
};

export default AnalyticsSMS;
